
import { CreateElement } from "vue";
import { Component, Inject, Vue } from "vue-property-decorator";
import { IContractProductProvider } from "@/models/providers/contractProduct";
// Import cProd messages
import CProdAutoExpireMsg from "@/components/app/global/contractProducts/cProdAutoExpireMsg.vue";
import CProdCancellationRequest from "@/components/app/global/contractProducts/cProdCancellationRequest.vue";
import CProdUnpaidInvoicesMsg from "@/components/app/global/contractProducts/cProdUnpaidInvoicesMsg.vue";
import CProdUnresolvedProvisionRequestsMsg from "@/components/app/global/contractProducts/cProdUnresolvedProvisionRequestsMsg.vue";
import CProdInherentlyLinkedMsg from "@/components/app/global/contractProducts/cProdInherentlyLinkedMsg.vue";
import DelegatedObjectMsg from "@/components/app/global/delegates/delegatedObjectMsg.vue";

@Component
export default class CProdMessages extends Vue {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }
  /**
   * @desc Here we render contract product messages using a render function,
   * otherwise we get unwanted whitespace which breaks the CSS :empty selector
   */
  public render(h: CreateElement) {
    return h("u-messages", {}, [
      h(CProdCancellationRequest),
      h(CProdUnresolvedProvisionRequestsMsg),
      h(CProdUnpaidInvoicesMsg),
      h(CProdAutoExpireMsg),
      h(CProdInherentlyLinkedMsg),
      this.cProdData.isDelegatedAccess &&
        h(DelegatedObjectMsg, {
          props: {
            objectType: this.$t("_.product") as string
          }
        })
    ]);
  }
}
